import classnames from 'classnames';
import React, { FunctionComponent } from 'react';

import { BaseTHead, BaseTHeadProps } from '../../base';

import classes from '../styles/selectable-table.module.scss';

export const THead: FunctionComponent<BaseTHeadProps> = (props) => {
  const { children, ...otherProps } = props;
  return (
    <BaseTHead
      {...otherProps}
      className={classnames('selectabeThead', classes.thead, props.className)}
    >
      {children}
    </BaseTHead>
  );
};
